import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const PremiumParamsTypeSelect = observer(({ store, disabled = false }) => {
  return (<>
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        options={store?.options()}
        //defaultValue={store?.selectedPremiumParameters ? store?.selectedPremiumParameters : []}
        value={store?.selectedPremiumParameters.map((param) => ({label: param.label, uuid: param.uuid}))}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.uuid}
        onChange={(data) => store?.selectParameters(data, "selectedPremiumParameters")}
        placeholder="Select"
        isMulti
        isDisabled={disabled}
      />
    </>
  );
});

export default PremiumParamsTypeSelect;
